import * as React from "react";
import {
  NewTaskPanelWrapper,
  NewTaskNameTextArea,
  NewTaskPanelButtonsWrapper,
  NewTaskNameWrapper,
} from "src/components/TaskListPanel/TaskList/NewTaskPanel/NewTaskPanel.components";
import {
  displayErrorToast,
  displayWarningToast,
} from "src/components/shared/Toasts/Toast";
import { ToastIds } from "src/enums/errorToastIds";
import { useGameContext } from "src/game/useGameContext";
import ButtonBordered from "src/components/shared/Button/ButtonBordered";

export interface Props {
  isAddingTask: boolean;
  onToggleNewTaskPanel: (value: boolean) => void;
}

export const NewTaskPanel: React.FunctionComponent<Props> = ({
  isAddingTask,
  onToggleNewTaskPanel,
}) => {
  const newTaskDescriptionRef = React.useRef<HTMLTextAreaElement>(null);
  const { gameState, actionHandlers } = useGameContext();

  const addNewTask = async () => {
    const newDesc = newTaskDescriptionRef?.current?.value;

    if (!newDesc || newDesc == "") {
      displayWarningToast("Cannot add a task without a title");
      return;
    }

    if (!gameState.game?.id || !gameState.token) {
      return;
    }

    const authData = {
      gameId: gameState.game?.id,
      token: gameState.token,
    };

    try {
      const response = await actionHandlers.addTask({
        ...authData,
        task: {
          description: newDesc,
        },
      });
      if (response.error) {
        displayErrorToast(
          `Failed to add task ${response.error.message}`,
          ToastIds.TASK_CREATE_FAILED
        );
      }
    } catch (e) {
      displayErrorToast(
        "Failed to add task${message}",
        ToastIds.TASK_CREATE_FAILED
      );
    }
  };

  return (
    <NewTaskPanelWrapper isVisible={isAddingTask}>
      <NewTaskNameWrapper>
        <NewTaskNameTextArea placeholder="Title" ref={newTaskDescriptionRef} />
      </NewTaskNameWrapper>
      <NewTaskPanelButtonsWrapper>
        <ButtonBordered
          themeColor="background"
          onClick={() => {
            onToggleNewTaskPanel(false);

            if (newTaskDescriptionRef?.current?.value) {
              newTaskDescriptionRef.current.value = "";
            }
          }}>
          Cancel
        </ButtonBordered>
        <ButtonBordered
          themeColor="buttonPrimary"
          onClick={() => {
            addNewTask();
            onToggleNewTaskPanel(false);
            if (newTaskDescriptionRef?.current?.value) {
              newTaskDescriptionRef.current.value = "";
            }
          }}>
          Add
        </ButtonBordered>
      </NewTaskPanelButtonsWrapper>
    </NewTaskPanelWrapper>
  );
};

export default NewTaskPanel;
